import React, { useContext, useState } from 'react';
import {
  IBusiness,
  IDeactivateAndActivateBusiness,
} from '../../../../interface/business';
import Button from '../../../../components/button';
import { useDeleteBusiness } from '../../../../services/business';
import { Modal } from '../../../../components/modal';
import ToastContext from '../../../../context/toast';
import Input from '../../../../components/input';

const DeleteBusiness = ({
  business,
  refetch,
  closeModal,
}: {
  business: IBusiness;
  refetch: any;
  closeModal: (v: boolean) => void;
}) => {
  const [open, setOpen] = useState(false);
  const [showToken, setShowToken] = useState<boolean>(false);
  const [openAccessKeyModal, setOpenAccessKeyModal] = useState(false);
  const [accessKey, setAccessKey] = useState<string>('');
  const { mutate, isLoading } = useDeleteBusiness();
  const { addToast } = useContext(ToastContext);

  const submit = () => {
    if (!accessKey) {
      addToast({
        msg: 'Please enter access Key',
        type: 'error',
      });
    } else {
      mutate(
        {
          id: business._id,
          payload: { secret: accessKey },
        },
        {
          onSuccess: () => {
            setOpenAccessKeyModal(false);
            closeModal(false);
            addToast({
              msg: 'Successfully Deleted',
              type: 'success',
            });
            refetch();
          },
        }
      );
    }
  };

  return (
    <>
      <div className=" w-auto">
        <Button
          className="font-medium !py-2"
          bgColor="bg-red-500"
          onClick={() => setOpen(true)}
          disabled={isLoading}
        >
          Delete Business
        </Button>
      </div>
      <Modal
        padding={false}
        isVisible={open}
        center
        close={setOpen}
        width="medium"
      >
        <div className="border-b border-grey">
          <div className="px-4 py-4 flex flex-col gap-6 items-center">
            <h4>Are you sure you want to Delete this Business?</h4>
            <div className="flex gap-4">
              <Button
                onClick={() => {
                  setOpenAccessKeyModal(true);
                  setOpen(false);
                }}
              >
                Yes, Continue
              </Button>
              <Button
                onClick={() => setOpen(false)}
                bgColor="bg-activeLinkBlack"
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        padding={false}
        isVisible={openAccessKeyModal}
        center
        width="medium"
        close={setOpenAccessKeyModal}
        title="Enter Access Key"
        header
        showFooter
        footer={
          <div className="flex justify-end gap-2">
            <Button loading={isLoading} disabled={isLoading} onClick={submit}>
              Submit
            </Button>
          </div>
        }
      >
        <div className="p-4">
          <p className="pb-2">
            <small className="w-1/4 text-textDimGray">Access key</small>
          </p>
          <Input
            name="secret"
            type={showToken ? 'text' : 'password'}
            value={accessKey}
            onChange={(e) => setAccessKey(e.target.value)}
            trailing={
              <p
                onClick={() => setShowToken(!showToken)}
                className="text-sm text-blue"
              >
                Show
              </p>
            }
          />
        </div>
      </Modal>
    </>
  );
};

export default DeleteBusiness;
